import deepSignApi from '@/api/deepsign/deepsignApi';

//TODO @daniel.henkiel missing api definition - missing BE swagger entry
export const getSealPreview = (sealId: string, sizeFactor: string | number) =>
  deepSignApi.post(
    `users/me/seals/${sealId}/preview`,
    { sizeFactor },
    {
      responseType: 'blob'
    }
  );
